import React, { useState, useEffect } from 'react';
import ServiceListData from './Data/ServiceListData';
import ColorPallet from '../../../../utils/ColorPallet';
import ImagesPallet from '../../../../utils/ImagesPallet';

function SecondSection() {
  const [activeTab, setActiveTab] = useState('papakilo-man');
  const [activeSubTab, setActiveSubTab] = useState('hair-treatments-man');

  // Add custom styles for scrollbar hiding
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .scrollbar-hide::-webkit-scrollbar {
        display: none;
      }
      .scrollbar-hide {
        -ms-overflow-style: none;
        scrollbar-width: none;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  // Set default active tab and subtab when component mounts
  useEffect(() => {
    setActiveTab('papakilo-man');
    setActiveSubTab('hair-treatments-man');
  }, []);

  const subCategories = {
    'papakilo-man': {
      'hair-treatments-man': 'Hair Treatments',
      'coloring': 'Coloring',
      'massage-treatments': 'Massage Treatments',
      'kids': 'Kids Menu',
      'smoothing-perm': 'Smoothing & Perm',
      'additional-treatments': 'Additional Treatments'
    },
    'papakilo-woman': {
      'hair-treatments-woman': 'Hair Treatments',
      'cut-styling': 'Cut & Styling',
      'coloring-perm': 'Coloring & Perm',
      'smoothing-keratin': 'Smoothing & Keratin',
      'papakilo-package': 'Papakilo Package'
    },
    'loreal': {
      'hair-treatments-loreal': 'Hair Treatments',
      'coloring-perm-loreal': 'Coloring & Perm',
      'smoothing-keratin-loreal': 'Smoothing & Keratin',
    }
  };

  const getCurrentServices = () => {
    if (ServiceListData[activeTab] && ServiceListData[activeTab][activeSubTab]) {
      return ServiceListData[activeTab][activeSubTab];
    }
    return [];
  };

  return (
    <div className="min-h-screen text-white p-8">
      <h1 className="text-4xl font-bold text-center mb-12" style={{ color: ColorPallet.primaryDarkBrown }}>
        PRICELIST
      </h1>
      
      {/* Main Tab Buttons */} 
      <div className="flex justify-center gap-8 mb-8">
        {[
          { id: 'papakilo-man', label: 'PAPAKILO MAN', icon: ImagesPallet.Man },
          { id: 'papakilo-woman', label: 'PAPAKILO WOMAN', icon: ImagesPallet.Woman },
          { id: 'loreal', label: "L'OREAL", icon: ImagesPallet.Loreal },
        ].map((tab) => (
          <div 
            key={tab.id}
            onClick={() => {
              setActiveTab(tab.id);
              // Set default subtab for each main tab
              const firstSubTab = Object.keys(subCategories[tab.id])[0];
              setActiveSubTab(firstSubTab);
            }}
            className={`text-center cursor-pointer transition-all duration-300 transform hover:scale-105 
              ${activeTab === tab.id ? 'opacity-100' : 'opacity-50'}`}
          >
            <img 
              src={tab.icon} 
              alt={tab.label} 
              className="w-16 h-16 mx-auto mb-2"
            />
            <span 
              className={`font-semibold ${activeTab === tab.id ? 'border-b-2' : ''}`}
              style={{ color: ColorPallet.primaryDarkBrown, borderColor: ColorPallet.primaryDarkBrown }}
            >
              {tab.label}
            </span>
          </div>
        ))}
      </div>

      {/* Sub Category Tabs */}
      {subCategories[activeTab] && Object.keys(subCategories[activeTab]).length > 0 && (
        <div className="relative mb-8">
          <div className="flex overflow-x-auto scrollbar-hide scroll-smooth whitespace-nowrap -mx-8 px-8 pb-4">
            <div className="flex gap-4 mx-auto">
              {Object.entries(subCategories[activeTab]).map(([key, label]) => (
                <button
                  key={key}
                  onClick={() => setActiveSubTab(key)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 flex-shrink-0
                    ${activeSubTab === key 
                      ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white' 
                      : 'bg-[#B8860B]/10 text-gray-500  00 hover:bg-purple-600/20'
                    }`}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
          {/* Scroll */}
          <div className="absolute left-0 top-0 bottom-4 w-8 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-4 w-8 pointer-events-none" />
        </div>
      )}

      {/* Price List Content */}
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
          {getCurrentServices().map((service, index) => (
            <div 
              key={index} 
              className="border border-dashed  border-purple-600 p-6 rounded-lg hover:bg-purple-600/20 transition-colors duration-300"
            >
              <div className="flex justify-between items-center mb-3">
                <h3 className="text-lg text-slate-800 font-semibold">{service.title}</h3>
                <span className="font-bold text-lg" style={{ color: ColorPallet.primaryDarkBrown }}>
                  {service.price}
                </span>
              </div>
              <p className="text-gray-600 capitalize">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SecondSection;